import { useContext } from "react";
import {
  ApplicationContext,
  type IApplicationContextType,
} from "@src/ApplicationContext";
import type { IExtractionState } from "./extraction/useExtraction";
import type { IDoctypeState } from "./flow/useDoctype";

const useIntelligenceEngine = (): IApplicationContextType => {
  const context = useContext(ApplicationContext);
  if (context === undefined) {
    throw new Error(
      "useIntelligenceEngine must be used within an ApplicationProvider",
    );
  }
  return context;
};

export const useExtraction = (): IExtractionState => {
  const { extraction } = useIntelligenceEngine();
  return extraction;
};

export const useDoctypes = (): IDoctypeState => {
  const { doctype } = useIntelligenceEngine();
  return doctype;
};
